import React from 'react'
import { CAREER_MERAH_OLD_ICON } from "assets/images"

const MemoizedImageMERAHOLD = () => {
  return (
    <img src={CAREER_MERAH_OLD_ICON} alt='' className='game-token-merah' />
  )
}
export default React.memo(MemoizedImageMERAHOLD) 
